module.exports = "https://images.shiksha.ws/saassets/media/AIRC-Logo.d923a497.png";